import { SetState } from 'zustand';
import { IFee } from '../pages/MailCheck/interfaces';
import { STEPS } from '../pages/MailCheck/consts';
import { ISupplier } from '../pages/Supplier/types';

export interface IMailCheckSlice {
    feeData: IFee;
    selectedLimit: {key: string, value: number};
    setFeeData: (payload: IFee) => void;
    setSelectedLimit: (payload: {key: string, value: number}) => void;
    activeStep: number;
    setActiveStep: (step: number) => void;
    payeeDetails: ISupplier | undefined;
    setPayeeDetails: (data: ISupplier) => void;
    resetMailCheckSlice: () => void;
    checkAmount: number;
    setCheckAmount: (value: number) => void;
    upperMessageContent: string;
    setUpperMessageContent: (content: string) => void;
    isMailCheckMemoAdded: boolean;
    setIsMailCheckMemoAdded: (status: boolean) => void;
}

const createMailCheckSlice = (set: SetState<IMailCheckSlice>) => ({
  feeData: {
    arrivalDate: '',
    fee: 0,
  },
  selectedLimit: {
    key: '',
    value: 0,
  },
  payeeDetails: undefined,
  activeStep: STEPS.LOADER,
  checkAmount: 0,
  upperMessageContent: '',
  isMailCheckMemoAdded: false,
  setFeeData: (feeData: IFee) => {
    set({ feeData });
  },
  setSelectedLimit: (payload: {key: string, value: number}) => {
    set({ selectedLimit: payload });
  },
  setActiveStep: (stepNumber: number) => {
    set(({ activeStep: stepNumber }));
  },
  setPayeeDetails: (data: ISupplier) => {
    set(({ payeeDetails: data }));
  },
  setCheckAmount: (value: number) => {
    set({ checkAmount: value });
  },
  setUpperMessageContent: (content: string) => {
    set({ upperMessageContent: content });
  },
  setIsMailCheckMemoAdded: (status: boolean) => {
    set({ isMailCheckMemoAdded: status });
  },
  resetMailCheckSlice: () => {
    set({
      payeeDetails: undefined,
      activeStep: STEPS.LOADER,
      checkAmount: 0,
      upperMessageContent: '',
      isMailCheckMemoAdded: false,
    });
  },
});

export default createMailCheckSlice;
